// extracted by mini-css-extract-plugin
export default {"summaryBox":"TimesheetDownloadModal_summaryBox__6oyXg","message":"TimesheetDownloadModal_message__yb8Y4","detailRow":"TimesheetDownloadModal_detailRow__CMw++"};